module.exports = __webpack_public_path__ + "img/01.691d6235.png";